import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../Auth/AuthContext'
import { useMutation, useQuery } from '@apollo/client'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import Loader from '../Global/Spinner'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { objNameRoles as roles } from '../../const/constRoles'
import { fnObjNameStatus as fnObjNameStatus_waterTruck } from '../../const/constStatuses_waterTruckRequest'
import WaterTruckRoutePoint from './components/WaterTruckRoutePoint'
import {
  FINISH_ROUTE_FROM_WATER_DRIVER,
  GET_ONE_ROUTE_BY_CONTEXT_USER_ID,
} from '../../graphql/Catalog/Trucks/Routes/routeWaterDriver'
import LayoutRoutePoints from './components/LayoutRoutePoints'

const statusesWaterTruck = fnObjNameStatus_waterTruck()

const DashboardTechnicalWaterTruck = () => {
  const _title = JSON.parse(localStorage.getItem('configSys'))
  const { user } = useContext(AuthContext)
  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [route, setRoute] = useState(null)
  const [scoreProgress, setScoreProgress] = useState(null)
  const [currentRoutePoint, setCurrentRoutePoint] = useState(null)

  //MUTATIONS
  const [finishRoute] = useMutation(FINISH_ROUTE_FROM_WATER_DRIVER)

  //QUERIES
  const { loading, error, data, refetch } = useQuery(
    GET_ONE_ROUTE_BY_CONTEXT_USER_ID,
    { fetchPolicy: 'network-only' }
  )

  //FUNCTIONS
  // const getNumberRoutesCompleted = () => {
  //   let count = 0
  //   const getStatusCompleted = statusesWaterTruck.completado
  //   route?.RouteToRoutePoints.map((point) => {
  //     if (point.RoutePointsToWaterTruckRequest.status_id === getStatusCompleted)
  //       count++
  //     // if (point.delivered_at !== null) count++
  //     return
  //   })
  //   return count
  // }

  const handleFinish = async () => {
    showLoading()
    try {
      await finishRoute({ variables: { route_id: parseInt(route.id) } })
      await refetch()
      return toastSweetAlert({
        mode: 'ok',
        message: 'Ruta finalizada',
      })
    } catch (e) {
      return toastSweetAlert({
        mode: 'error',
        message: e.message,
      })
    } finally {
      hideLoading()
    }
  }

  const showRoutePointCurrent = () => {
    if (!currentRoutePoint) return
    const routePoint = route?.RouteToRoutePoints.find(
      (point) => currentRoutePoint?.id === point.id
    )
    if (routePoint)
      return (
        <WaterTruckRoutePoint
          routePoint={routePoint}
          refetch={refetch}
          setCurrentRoutePoint={setCurrentRoutePoint}
        />
      )

    return (
      <div className="col-12">
        <div className="alert alert-default-success">
          <i className="fas fa-check mr-2" />
          Terminaste todas los puntos asignados.
        </div>
        <div className="text-right">
          <button
            type="button"
            className="btn btn-accept-login btn-lg"
            style={{ fontSize: '1.15rem' }}
            onClick={() => handleFinish()}
          >
            Finalizar <i className="fas fa-check ml-1" />
          </button>
        </div>
      </div>
    )
  }

  //EFFECTS
  useEffect(() => {
    try {
      if (loading) return
      if (error) throw error
      if (!data) throw new Error('No se encontraron datos')

      setRoute(data.getOneRouteByContextUserId.routes)
      setScoreProgress({
        completedPoints: data.getOneRouteByContextUserId.completedPoints,
        totalPoints: data.getOneRouteByContextUserId.totalPoints,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, error, loading])

  useEffect(() => {
    document.title = `${_title?.project_name} | Dashboard pipas`
  }, [_title?.project_name])

  useEffect(() => {
    try {
      if (!route) return
      if (route.RouteToRoutePoints.length === 0) return

      // if (currentRoutePoint) {
      //   const findRoutePoint = route.RouteToRoutePoints.find(
      //     (point) => point.id === currentRoutePoint.id
      //   )
      //   if (
      //     findRoutePoint.loaded_at !== null &&
      //     findRoutePoint.delivered_at !== null &&
      //     findRoutePoint.RoutePointsToWaterTruckRequest.status_id ===
      //       statusesWaterTruck.completado
      //   ) {
      //     return setCurrentRoutePoint(null)
      //   }

      //   if (findRoutePoint.loaded_at !== null) {
      //     return setCurrentRoutePoint(findRoutePoint)
      //   }

      //   return
      // }

      const routePoint = route.RouteToRoutePoints.find((point) => {
        if (point.loaded_at === null) {
          return true
        }
        if (point.delivered_at === null) {
          return true
        }
        if (
          point.RoutePointsToWaterTruckRequest.status_id !==
          statusesWaterTruck.completado
        ) {
          return true
        }
      })

      setCurrentRoutePoint(routePoint)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [route])

  //RENDER 1
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center flex-column my-3 w-100">
        <div className="mb-2">
          <small>Cargando...</small>
        </div>
        <Loader size={'2rem'} />
      </div>
    )
  }

  //RENDER 2
  if (user?.role !== roles.chofer_pipas) {
    return (
      <div className="col-12">
        <div className="pt-3">
          <div className="alert alert-default-info">
            <i className="fas fa-info-circle mr-2" />
            Este contenido es exclusivo para rol "chofer de pipas".
          </div>
        </div>
      </div>
    )
  }

  //RENDER 3
  if (!loading && data && (!route || !route?.id)) {
    return (
      <>
        <div className="row px-2 mb-4 pt-4">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body px-3 py-2">
                <div>
                  <small>Bienvenido</small>
                </div>
                <h4 className="fw-bold">
                  <strong>
                    {user.name}
                    {user?.first_name ? ` ${user?.first_name}` : ''}
                    {user?.last_name ? ` ${user?.last_name}` : ''}
                  </strong>
                </h4>
                <div className="pt-2">
                  <div className="alert alert-default-info">
                    <i className="fas fa-info-circle mr-2" />
                    Por el momento no tienes una ruta asignada.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  //RENDER MAIN
  return (
    <div className="px-3 dashboard-waterTruck">
      <div className="row mb-1 pt-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-body px-3 py-2">
              <div>
                <small>Bienvenido</small>
              </div>
              <h4 className="fw-bold">
                <strong>
                  {user.name} {user.first_name ?? ''} {user?.last_name ?? ''}
                </strong>
              </h4>
              <p>Esperamos que tengas un buen día en tu ruta.</p>
              <div>
                <strong>Rutas a recorrer:</strong>
                <span className="text-primary ml-1">
                  {scoreProgress?.totalPoints}
                  {/* {route?.RouteToRoutePoints && route.RouteToRoutePoints.length} */}
                </span>
              </div>
              <div>
                <strong>Rutas completadas:</strong>{' '}
                <span className="text-success">
                  {scoreProgress?.completedPoints}
                  {/* {route?.RouteToRoutePoints && getNumberRoutesCompleted()} */}
                </span>
              </div>
              <div className="mt-2">
                {route && route.RouteToRoutePoints && (
                  <LayoutRoutePoints
                    routesPoints={route.RouteToRoutePoints}
                    currentRoutePoint={currentRoutePoint}
                    setCurrentRoutePoint={setCurrentRoutePoint}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-1">
        <div className="col-12 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-header primary px-2 py-1">
              <h5 className="card-title">
                <i className="fas fa-truck mr-1" />
                <strong>Información camión</strong>
              </h5>
            </div>
            <div className="card-body px-3 pt-2 pb-1">
              <span> {route?.RouteToTrucks?.plate_number ?? 'N/A'}</span>
              {route?.RouteToTrucks?.type ? (
                <span className="ml-1" style={{ fontSize: 10 }}>
                  ({route?.RouteToTrucks?.type})
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-2 pb-2">
        {route?.RouteToRoutePoints && showRoutePointCurrent()}
      </div>
    </div>
  )
}

export default DashboardTechnicalWaterTruck
